import React from "react";
import Robot from '../img/snappbot.png'

export const Snappbot = () =>
    <div className="col-md-2 col-lg-2">
        <img className="robot" src={Robot} alt=""/>
    </div>
